import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useChDeleteMedicationMutation as useChDeleteMedicationMutationType } from "@/modules/patients/detail/medication/ch/services/__generated__/useChDeleteMedicationMutation.graphql"

const mutation = graphql`
  mutation useChDeleteMedicationMutation($input: Ch_deleteMedicationInput!, $connections: [ID!]!) {
    ch_deleteMedication(input: $input) {
      ch_Medication {
        id @deleteEdge(connections: $connections)
        ...chMedicationFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useChDeleteMedicationMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChDeleteMedicationMutationType>(mutation, params)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChDeleteMedicationMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChDeleteMedicationMutation }
